import { useQuery } from "@tanstack/react-query";
import { getPodcastsApi } from "../../../api/resources.api";
import { PodcastResponse } from "../../../../src/types/index";

export const usePodcasts = () => {
  return useQuery<PodcastResponse, Error>({
    queryKey: ["podcasts"],
    queryFn: async () => {
      const res: PodcastResponse = await getPodcastsApi();

      if (!res?.status || !Array.isArray(res.data)) {
        throw new Error("Invalid podcast data");
      }

      return res;
    },
  });
};
